import { computed } from 'vue';
import { concat, map, omitBy } from 'lodash-es';

// eslint-disable-next-line max-params
export const useSummary = (props, getOptionParam, getOptionItemParam, configuration, formattedTotalPrice) => {
  const summary = computed(() => ({
    items: concat(
      [
        {
          label: getOptionItemParam(
            'engravings',
            configuration.value.engraving,
            'label',
            configuration.value.engraving,
          ),
          value: getOptionItemParam('engravings', configuration.value.engraving, 'formattedPrice'),
        },
      ],
      map(
        omitBy(configuration.value.options, (value) => value === null),
        (value, key) => ({
          label: getOptionParam(props.matchConfigurationIds[key], 'label', key),
          value: getOptionItemParam(props.matchConfigurationIds[key], value, 'formattedPrice', null, true),
        }),
      ),
    ).filter((item) => item.value !== null),
    total: formattedTotalPrice.value,
  }));

  return {
    summary,
  };
};
